import { t } from 'Src/i18n';

function pluralizeLabel(singularLabel: string, pluralLabel: string, value: number): string {
  return value > 1 ? pluralLabel : singularLabel;
}

function prefixWithPlusIfPositive(value: number, label: string): string {
  return value >= 0 ? `+${label}` : label;
}

function capitalizeName(text?: string): string {
  return (text || '').toLowerCase().replace(/(?:^|[-\s.'&])\S/g, (a) => a.toUpperCase());
}

export const getAttendeesSummary = ({
  adultsCount,
  kidsCount,
}: {
  adultsCount: number;
  kidsCount: number;
}): string =>
  `${adultsCount} ${pluralizeLabel(t('booking.common.adult'), t('booking.common.adults'), adultsCount)} ${kidsCount > 0 ? ` - ${kidsCount} ${pluralizeLabel(t('booking.common.child'), t('booking.common.children'), kidsCount)}` : ''}`;
export const getTravelSectionSummary = ({
  travelSection,
}: {
  travelSection: TravelSectionBound;
}): string => `${travelSection.label.toLowerCase()} (${travelSection.id.toUpperCase()})`;
export { pluralizeLabel, prefixWithPlusIfPositive, capitalizeName };
